import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-managemodules',
  templateUrl: './managemodules.component.html',
  styleUrls: ['./managemodules.component.scss']
})
export class ManagemodulesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
